// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-preparation-Diploma-Diploma-module__pageLayout-C4k5FE","header":"src-app-pages-electronic-preparation-Diploma-Diploma-module__header-zFh_Uz","headerTable1":"src-app-pages-electronic-preparation-Diploma-Diploma-module__headerTable1-dNYWyL","headerTable2":"src-app-pages-electronic-preparation-Diploma-Diploma-module__headerTable2-RczFHw","title":"src-app-pages-electronic-preparation-Diploma-Diploma-module__title-LuC1DD","contents":"src-app-pages-electronic-preparation-Diploma-Diploma-module__contents-SRGiQH"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-preparation-Diploma-Diploma-module__pageLayout-C4k5FE\",\"header\":\"src-app-pages-electronic-preparation-Diploma-Diploma-module__header-zFh_Uz\",\"headerTable1\":\"src-app-pages-electronic-preparation-Diploma-Diploma-module__headerTable1-dNYWyL\",\"headerTable2\":\"src-app-pages-electronic-preparation-Diploma-Diploma-module__headerTable2-RczFHw\",\"title\":\"src-app-pages-electronic-preparation-Diploma-Diploma-module__title-LuC1DD\",\"contents\":\"src-app-pages-electronic-preparation-Diploma-Diploma-module__contents-SRGiQH\"}";
        // 1789362522832
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  